<template>
  <b-card class="d-flex justify-content-center mb-3">
    <div v-if="!loaded && !showError" class="d-flex justify-content-center mb-3 mt-3">
      <b-spinner></b-spinner>
    </div>
    <b-row v-if="showError">
      <b-col class="col-12 col-md-6 mb-3">
        <b-card>
          <p class="text-center">{{ $t('rating.error') }}</p>
        </b-card>
      </b-col>
    </b-row>
    <div v-if="loading" class="d-flex justify-content-center mb-3 mt-3">
      <b-spinner></b-spinner>
    </div>
    <b-container>
      <b-row>
        <b-col class="flex-grow-0">
          <b-row class="p-2">&nbsp;</b-row>
          <rating-labels></rating-labels>
        </b-col>
        <b-col class="slider">
          <b-row class="pt-2 pb-2 flex-nowrap">
            <b-col v-for="(rating, i) in data" :key="i" class="col-4 col-md-4 font-sm text-center">
              <b-link v-html="formatDate(rating.date)" @click="checkNetworkUpdate(rating.id)" class="edit-link"></b-link>
            </b-col>
          </b-row>
          <b-row v-for="value in Object.keys($t('rating.items'))" class="pt-2 pb-2 flex-nowrap" :key="value">
            <b-col v-for="(rating, i) in data" :key="i" class="col-4 col-md-4">
              <rating-select :value="rating[value]" :disabled="true"></rating-select>
            </b-col>
          </b-row>
          <b-row class="pt-2 pb-2 flex-nowrap">
            <b-col v-for="(rating, i) in data" :key="i" class="col-4 col-md-4">
              <rating-delete :id=" rating.id" :colony="id" :apiary="apiary" @confirmDelete="onClickDelete($event)"></rating-delete>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-modal :id="'offLineModalRating'" centered hide-header-close @ok="hideModal" class="network-modal">
        <template slot="modal-title">
          {{ $t('offLineModal.title') }}
        </template>
        {{ $t('offLineModal.text') }}
        <template slot="modal-footer" class="offline-modal-footer" slot-scope="{ ok }">
          <b-button size="lg" class="mt-3" @click="ok()">
            {{ $t('offLineModal.ok') }}
          </b-button>
        </template>
      </b-modal>
    </b-container>
  </b-card>
</template>

<script>
import moment from 'moment'
import RatingSelect from './RatingSelect'
import RatingDelete from './RatingDelete'
import RatingLabels from './RatingLabels'
// import _ from 'lodash'

export default {
  name: 'RatingList',
  components: { RatingLabels, RatingSelect, RatingDelete },
  props: ['id', 'apiary', 'archive'],
  data () {
    return {
      showError: false,
      loading: false,
      data: null
    }
  },
  computed: {
    loaded () {
      return !!this.data
    }
  },
  methods: {
    checkNetworkUpdate (ratingId) {
      if (navigator.onLine) {
        this.$router.replace('/rating/edit/' + ratingId + '/' + this.id + '/' + this.apiary)
      } else {
        this.showOffLineModal()
      }
    },
    showOffLineModal () {
      this.$bvModal.show('offLineModalRating')
    },
    hideModal () {
      this.$bvModal.hide('offLineModalRating')
    },
    formatDate (date) {
      return moment(date).format('DD[.]MM[.<span class="d-none d-sm-inline">]YYYY[</span>]')
    },
    async loadData () {
      try {
        this.data = (await this.$api.ratings.getAll(this.id)) || []

        if (!this.archive) {
          this.data = this.data.slice(0, 6)
        }
      } catch (e) { // network error etc.
        this.data = null
      }

      this.showError = !this.data
      return this.data
    },
    async onClickDelete (value) {
      if (value) {
        this.loading = true
        try {
          const token = await this.$api.user.getToken()
          const result = await this.$api.ratings.delete({
            id: value,
            colony: this.id,
            token
          })
          console.log(result)
          this.data = (await this.$api.ratings.getAll(this.id)) || []
          if (!this.archive) {
            this.data = this.data.slice(0, 6)
          }
          this.loading = false
        } catch (e) {
          this.loading = false
          if (e.response && e.response.status === 403) {
            this.$router.replace('/login')
          }
        }
        this.showError = !this.data
        return this.data
      }
    }
  },
  mounted () {
    this.loadData()
  }
}
</script>

<style lang="scss" scoped>
  @import '../scss/config';

  .font-sm {
    //font-size: 12px;
    line-height: 1.5rem;
    white-space: nowrap;
    font-family: $font-family-sans-serif;
  }

  .slider {
    overflow-x: scroll;
    padding-bottom: 1rem;
  }
  .edit-link {
    text-decoration: underline;
  }
  .network-modal {
    font-family: $font-family-sans-serif;
  }

</style>
